import React from "react";
import { motion } from "framer-motion";

/**
 * Editorial chapter opener used at the top of every homepage section.
 * Gives the page a unified cinematic rhythm: CHAPTER 03 — THE METHOD.
 *
 * Props:
 *  - index: "01" .. "12"
 *  - label: overline text (e.g., "THE METHOD")
 *  - align: "left" | "center"
 */
export default function ChapterMark({ index, label, align = "left", className = "" }) {
  const isCenter = align === "center";
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className={`flex items-center gap-5 ${isCenter ? "justify-center" : "justify-start"} ${className}`}
      data-testid={`chapter-mark-${index}`}
    >
      <span className="font-mono text-[0.62rem] text-gold tracking-[0.4em]">CHAPTER {index}</span>
      <span className="h-px w-12 lg:w-20 bg-gradient-to-r from-gold/60 via-glow/40 to-transparent" />
      <span className="font-mono text-[0.62rem] text-ag-text-muted tracking-[0.32em] uppercase">{label}</span>
    </motion.div>
  );
}
